import React, { useEffect, useState } from 'react';
import './RetailerDetails.css';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import loader from '../Images/loader.gif'
import NoCompanyLogo from '../Images/NoCompanyLogo.png';
import Popup from './Popup'
import { Button, Link, Tooltip, CircularProgress } from '@material-ui/core';
import CallRetailer from './Retailer/CallRetailer'
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.webp';
import FacebookIcon from '../Images/facebook-new.png';
import { getRetailerProfile } from '../Backend/firebase/user';
import CustomAlert from './CustomAlert';
import ProductTemplate from './ProductTemplate';
import { MetaTags } from 'react-meta-tags';
import { loadInitial } from '../Backend/firebase/events';
import DetailsSkeleton from './DetailsSkeleton';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function RetailerDetails() {
    const { uid } = useParams();
    const [retailerDetails, setRetailerDetails] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [openCallRetailer, setOpenCallRetailer] = useState(false)
    const history = useHistory();
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [showPerPage, setShowPerPage] = useState(15);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage
    });
    const query = useQuery();

    useEffect(() => {
        // Returns the cleanup function
        return () => {
            const metaTag = document.querySelector(`meta[content="Web site created using create-react-app"]`);
            if (metaTag) {
                metaTag.remove();
            }
        }
    }, []);

    useEffect(() => {
        fetchRetailer();
    }, [uid]);

    const fetchRetailer = async () => {
        try {
            const getRetailerDetails = await getRetailerProfile(uid);
            setRetailerDetails("retailer" in getRetailerDetails ? getRetailerDetails?.retailer : null);
            setAllProducts("products" in getRetailerDetails ? getRetailerDetails?.products : []);
        } catch(error) {
            console.log("Error Occur in Get Retailer Profile", error)
        }
    }

    const callToRetailer = (mobile) => {
        // setOpenCallRetailer(true)
        window.open(`tel:${mobile}`, '_blank', 'noopener,noreferrer');
    }

    return (
        <>
            {retailerDetails ?
                <div className="container-fluid">
                    <div className="wrapper">
                        <MetaTags>
                            <meta charSet="utf-8" />
                            <meta name="description" content={retailerDetails?.storeName} />
                            <meta property="og:description" content={retailerDetails?.storeName} />
                            <meta property="og:title" content={retailerDetails?.storeName} />
                            <meta property="og:image" itemprop="image primaryImageOfPage" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                            <meta property="og:image:height" content="200" />
                            <meta property="og:image:width" content="200" />
                            <meta name="twitter:description" property="og:description" content={retailerDetails?.storeName} />
                            <meta name="twitter:title" content={retailerDetails?.storeName} />
                            <meta name="twitter:image" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                            <meta name="og:url" content={window.location.href} />
                            <title>{retailerDetails?.storeName}</title>
                            {/* <link rel="image_src" href={retailerDetails?.retailerImage ? retailerDetails?.retailerImage : NoCompanyLogo} /> */}
                            <link rel="canonical" href={window.location.href} />
                        </MetaTags>
                    </div>
                    <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5">
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="productDetail__productHead">
                                            {retailerDetails?.retailerImage ? <div className="retailerDetail__companyInfoLogo">
                                                    <img src={retailerDetails?.retailerImage} alt="Store Name" className="img-fluid retailerDetail__companyInfoLogo" />
                                                </div>
                                                : <div className="retailerDetail__companyInitialLogo">
                                                    <div className="logoInitial">{loadInitial(retailerDetails.storeName)}</div>
                                                </div>
                                            }
                                        </div><br />
                                    </div>
                                    <div className="col-md-5">
                                        <div className="productDetail__companyInfo">
                                            {retailerDetails && <h5 className="MainColor">{retailerDetails.storeName}</h5>}
                                            {retailerDetails.storeAddress}, {retailerDetails.country} {retailerDetails.zipcode ? `- ${retailerDetails.zipcode}` : ''}
                                            {retailerDetails.gstNo && <p className="productDetail__title">GST No: {retailerDetails.gstNo}</p>}
                                            <p className="productDetail__title">{retailerDetails.homeDelivery == "Yes" ? `Deliver medicines within ${retailerDetails.areaCovers}` : ''}</p>
                                            <div className="col-md-12 mt-4">
                                                <div className="jobDetail__applyJobsShare">
                                                    <div className="jobDetail__socialIcons">
                                                        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}?utm_source=linkedin&utm_medium=social&utm_campaign=linkedin_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '8px' }}>
                                                            <Tooltip title="Share this post via linkedIn" placement="top">
                                                                <img src={LinkedInIcon} alt="linkedin-icon" width="20px" height="20px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}?utm_source=facebook&utm_medium=social&utm_campaign=facebook_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '5px' }}>
                                                            <Tooltip title="Share this post via facebook" placement="top">
                                                                <img src={FacebookIcon} alt="facebook-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://twitter.com/intent/tweet?url=${window.location.href}?utm_source=twitter&utm_medium=social&utm_campaign=twitter_social_vac_share&text=${retailerDetails.storeName}`} target="_blank">
                                                            <Tooltip title="Share this post via twitter" placement="top">
                                                                <img src={TwitterIcon} alt="twitter-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                    </div>
                                                </div><br />
                                            </div>
                                            <div className="mt-4">
                                                <Button 
                                                    variant="contained" 
                                                    color="primary" className="navbar__btnLogin"
                                                    onClick={()=> callToRetailer(retailerDetails.phoneNumber)}>
                                                    Call Now
                                                </Button>
                                            </div><br />
                                        </div>
                                    </div>
                                </div>
                                {(allProducts && allProducts.length > 0 ) && <div className="row mt-5">
                                    <div className="col-md-12 mb-3 mt-3">
                                        <span style={{ color: '#000', fontWeight: '500', fontSize: '20px' }}>Products</span>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <div className="searchResult row">
                                            {
                                                allProducts.slice(pagination.start, pagination.end).map((product) => {
                                                    return <ProductTemplate key={product.id} ProductId={product.uniqueId} Image={NoCompanyLogo} Compostions={product.Compostions}
                                                        ProductName={product.ProductName} MRP={product.MRP} PackagingSize={product.PackagingSize} Discount={product.Discount} PostedDate={product.ProductPostedDateTime}
                                                        RetailerUid={uid} StoreName={retailerDetails.storeName} StoreAddress={retailerDetails.storeAddress} />
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                : <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                        <div className="productDetail mt-5 text-center justify-center">
                            <DetailsSkeleton isRetailer={true} />
                        </div>
                    </div>
                </div>
            }
            <Popup
                openPopup={openCallRetailer}
                setOpenPopup={setOpenCallRetailer}
                title="Retailer Enquiry"
                popupSize={'md'}
            >
                <CallRetailer isCaptchaVisible={true} retailerDetails={retailerDetails} allProducts={allProducts} />
            </Popup>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default RetailerDetails

